export default class LocalizationLabels {
	// omni labels
	static omni(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
			sortLabel: props.sortLabel,
		};

		return labels;
	}

	// there will be labels for other applications
	static partners(props) {
		const labels = {
            updatedResultsText: props.updatedResultsText,
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};

		return labels;
	}

	static careers(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};

		return labels;
	}

	static distributors(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};

		return labels;
	}

	static press(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};

		return labels;
	}

	static support(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};
		return labels;
	}

	static ebooks(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
			ebookAddToCartLabel: props['searchResults.ebook.addToCartLabel'],
			ebookByLabel: props['searchResults.ebook.byLabel'],
			ebookCoverAlt: props['searchResults.ebook.coverAlt'],
			ebookNoPriceLabel: props['searchResults.ebook.noPriceLabel'],
			ebookNoPriceLink: props['searchResults.ebook.noPriceLink'],
			ebookCardViewDetailsLabel: props['searchResults.ebookCard.viewDetailsLabel'],
			ebookDetailsBookDetailsTitle: props['searchResults.ebookDetails.bookDetailsTitle'],
			ebookDetailsProductDetailsLabel: props['searchResults.ebookDetails.productDetailsLabel'],
			ebookDetailsEISBNLabel: props['searchResults.ebookDetails.eISBNLabel'],
			ebookDetailsPageCountLabel: props['searchResults.ebookDetails.pageCountLabel'],
			ebookDetailsPublishDateLabel: props['searchResults.ebookDetails.publishDateLabel'],
			ebookDetailsSalesPriceLabel: props['searchResults.ebookDetails.salesPriceLabel'],
		};

		return labels;
	}

  static events(props) {
		const labels = {
			resultsLabel: props.resultsLabel,
			resultLabel: props.resultLabel,
			clearFilterLabel: props.clearFilterLabel,
			filterLabel: props.filterLabel,
			searchInputMessage: props.searchInputMessage,
			promoSectionHeading: props.promoSectionHeading,
			applicationName: props.applicationName,
		};

		return labels;
	}

}
